
import Loadable from "@loadable/component"


const LoadableChart = Loadable(() => import("./Chart"));
export default LoadableChart;